import {
  configureStore,
  createImmutableStateInvariantMiddleware,
  createSerializableStateInvariantMiddleware,
} from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import createSagaMiddleware from "redux-saga";
import { fork, all } from "redux-saga/effects";

import { sagas as experimentSearchSagas, reducer as experimentSearch } from "./experimentSearch";
import {
  sagas as experimentSamplesAggregateSagas,
  reducer as experimentSamplesAggregate,
} from "./experimentSamplesAggregate";
import { sagas as experimentSampleDataSagas, reducer as experimentSampleData } from "./experimentSampleData";
import {
  sagas as experimentSamplesPlotDataSagas,
  reducer as experimentSamplesPlotData,
} from "./experimentSamplesPlotData";
import { sagas as mdSearchSagas, reducer as mdSearch } from "./mdSearch";
import { sagas as mdTrajectoriesAggregateSagas, reducer as mdTrajectoriesAggregate } from "./mdTrajectoriesAggregate";
import { sagas as mdTrajectoryDataSagas, reducer as mdTrajectoryData } from "./mdTrajectoryData";
import { reducer as auth } from "./auth";

const sagaMiddleware = createSagaMiddleware();
function* rootSaga() {
  const allSagaMaps = [
    experimentSearchSagas,
    experimentSamplesAggregateSagas,
    experimentSampleDataSagas,
    experimentSamplesPlotDataSagas,
    mdSearchSagas,
    mdTrajectoriesAggregateSagas,
    mdTrajectoryDataSagas,
  ];

  const forkedSagas = allSagaMaps.flatMap((sagaMap) => Object.values(sagaMap)).map((saga) => fork(saga));

  yield all(forkedSagas);
}

const reducerMap = {
  experimentSearch,
  experimentSamplesAggregate,
  experimentSampleData,
  experimentSamplesPlotData,
  mdSearch,
  mdTrajectoriesAggregate,
  mdTrajectoryData,
  auth,
};

const immutableStateInvariantMiddleware = createImmutableStateInvariantMiddleware({});
const isSerializableStateInvariantMiddleware = createSerializableStateInvariantMiddleware({});

export const store = configureStore({
  reducer: combineReducers(reducerMap),
  middleware: [immutableStateInvariantMiddleware, isSerializableStateInvariantMiddleware, sagaMiddleware],
});

sagaMiddleware.run(rootSaga);
